(function () {
    'use strict';
    angular
        .module('app')
        .directive('confirmBox', confirmBox);
    confirmBox.$inject = ['$window', '$rootScope', '$scope', '$timeout', 'ngClipboard', '$mdDialog'];
    function confirmBox($window, $rootScope, scope, $timeout, ngClipboard, $mdDialog) {
        var directive = {
            link: link,
            restrict: 'EA',
            //scope: {
            //    msgBoxShown: '=?'
            //},
            //controller: 'confirmBox',
            templateUrl: 'app/msgBox/confirmBox.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();